import { PRRangeElement } from "../Charts/Chart"
import { chartMap } from "../Map"

export const ChartPr = ({ teststatPR }) => {
  //console.log(teststatPR[0])
  return (

    <div className="chart_pr">
      {
        chartMap.pr.map((e) => {
          return <PRRangeElement title={e} val={teststatPR[0][chartMap.prString[e]]} key={e} />
        })}
    </div>
  )
}

const ChartPrItem = ({ title, val }) => {
  function left(v) {
    return v * 0.8
  }
  return (
    <div className="pr_block">
      <div className="pr_topic">{title}</div>
      <div className="range-div">
        <input type="range" name="" className={"range range_color"+parseInt((val/10)+1)} min="0" max="100" step="1" value={val} disabled />
        <span className="range-thumb" data-val={val} style={{ left: left(val), color:"#FFF" }} ></span>
      </div>
    </div>
  )
}